import React from 'react';

type Props = {
  color?: string;
};

const defaultProps = {
  color: '#A0A0A0',
};

const ShareArticleIcon: React.FC<Props> = function ShareArticleIcon({ color }) {
  return (
    <svg width="14" height="14" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="share-article-icon-svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.5 0C8.17701 0 7.88768 0.142105 7.69281 0.366364L4.7435 3.27437C4.32856 3.68349 4.32856 4.34681 4.7435 4.75593C5.15843 5.16505 5.83117 5.16505 6.2461 4.75593L7.4375 3.58121V13.619C7.4375 14.1976 7.9132 14.6667 8.5 14.6667C9.0868 14.6667 9.5625 14.1976 9.5625 13.619V3.58121L10.7539 4.75593C11.1688 5.16505 11.8416 5.16505 12.2565 4.75593C12.6714 4.34681 12.6714 3.68349 12.2565 3.27437L9.30719 0.366364C9.11232 0.142105 8.82299 0 8.5 0ZM14.875 7.33333H13.8125C13.2257 7.33333 12.75 7.80237 12.75 8.38095C12.75 8.95954 13.2257 9.42857 13.8125 9.42857H14.875V19.9048H2.125V9.42857H3.1875C3.7743 9.42857 4.25 8.95954 4.25 8.38095C4.25 7.80237 3.7743 7.33333 3.1875 7.33333H2.125C0.951395 7.33333 0 8.2714 0 9.42857V19.9048C0 21.0619 0.951395 22 2.125 22H14.875C16.0486 22 17 21.0619 17 19.9048V9.42857C17 8.2714 16.0486 7.33333 14.875 7.33333Z" fill={color} />
    </svg>
  );
};

ShareArticleIcon.defaultProps = defaultProps;

export default ShareArticleIcon;
